module.exports = __webpack_public_path__ + "static/media/SS.27d0b93c.webp";